import IntlErrorBoundary from '_common/components/IntlErrorBoundary/IntlErrorBoundary';
import TableContent, { type TableProps } from './TableContent';
import ThunkTable, { type ThunkTableProps } from './ThunkTable';
import { TableRow } from './Table';
export * from './Table';
export * from './Cells';
export { default as Footer } from './Footer/Footer';
export { default as SelectionCounter } from './Footer/SelectionCounter';

export const Table = <T extends TableRow = TableRow & { id: string }>(props: TableProps<T>) => {
  return (
    <IntlErrorBoundary size="xl" style={{ margin: '8.5rem 0 0 0' }}>
      <TableContent {...props} />
    </IntlErrorBoundary>
  );
};

export const ThunksTable = <T extends TableRow = TableRow & { id: string }>(
  props: ThunkTableProps<T>,
) => {
  return (
    <IntlErrorBoundary size="xl" style={{ margin: '8.5rem 0 0 0' }}>
      <ThunkTable {...props} />
    </IntlErrorBoundary>
  );
};

export { ThunkTableProps, TableProps };
